import { render, staticRenderFns } from "./ListadoAreaUniversidad.vue?vue&type=template&id=b3aede38"
import script from "./ListadoAreaUniversidad.vue?vue&type=script&lang=js"
export * from "./ListadoAreaUniversidad.vue?vue&type=script&lang=js"
import style0 from "./ListadoAreaUniversidad.vue?vue&type=style&index=0&id=b3aede38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports